import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import CodeRow from './CodeRow/CodeRow'
import { codeTypes } from './CodeRow/constants'
import { decisions } from './constants'
import { getHsCodeState, getHtsCodeState, itemHasHtsCode } from './helpers'
import * as Styles from './styles'

const DraftItem = ({
  item,
  showHts,
  hsDecision,
  htsDecision,
  onHsAccept,
  onHsDiscard,
  onHsUndo,
  onRestoreHs,
  onHtsAccept,
  onHtsDiscard,
  onHtsUndo,
  onRestoreHts,
  position,
}) => {
  const theme = useTheme()
  const hsCodeState = getHsCodeState(item?.hs_code, item?.proposed_hs_code, item?.is_valid_hs_code)
  const htsCodeState = showHts
    ? getHtsCodeState(item?.hts_code, item?.proposed_hts_code, item?.is_valid_hts_code)
    : null
  const hsIsDiscarded = hsDecision === decisions.discarded

  return (
    <Styles.Container>
      <Styles.ProductHeader>
        <Text type="allCapsM" color={theme.colors.text.muted}>
          {position}
        </Text>
        <Styles.ProductImage src={item?.image_url || '/images/placeholderImg.png'} alt={item?.name} />
        <Styles.ProductInfo>
          <Text type="titleS">{item?.title}</Text>
          <Text type="allCapsM">{item?.sku}</Text>
        </Styles.ProductInfo>
      </Styles.ProductHeader>
      <Styles.CodeRows>
        <CodeRow
          codeType={codeTypes.hs}
          currentCode={item?.hs_code}
          currentDescription={item?.hs_code_description}
          proposedCode={item?.proposed_hs_code}
          proposedDescription={item?.proposed_hs_code_description}
          codeState={hsCodeState}
          decision={hsDecision}
          showHts={showHts}
          onAccept={() => onHsAccept(item?.id)}
          onDiscard={() => onHsDiscard(item?.id)}
          onUndo={() => onHsUndo(item?.id)}
          onRestore={() => onRestoreHs(item?.id)}
        />
        {showHts && !hsIsDiscarded && itemHasHtsCode(item) && (
          <CodeRow
            codeType={codeTypes.hts}
            currentCode={item?.hts_code}
            currentDescription={item?.hts_code_description}
            proposedCode={item?.proposed_hts_code}
            proposedDescription={item?.proposed_hts_code_description}
            codeState={htsCodeState}
            decision={htsDecision}
            showHts={false}
            onAccept={() => onHtsAccept(item?.id)}
            onDiscard={() => onHtsDiscard(item?.id)}
            onUndo={() => onHtsUndo(item?.id)}
            onRestore={() => onRestoreHts(item?.id)}
          />
        )}
      </Styles.CodeRows>
    </Styles.Container>
  )
}

export default DraftItem
